import createStore from "@/store/index.js";
import { createRouter } from "@/router/index.js";
import VueGtag from "vue-gtag";
import VueAgile from "vue-agile";
import VueZoomer from "vue-zoomer";
import { sync } from "vuex-router-sync/dist/vuex-router-sync.esm-browser.prod";
import { createMetaManager, defaultConfig } from "vue-meta";
import { createPinia } from "pinia";

function addPlugins(app) {
  app.use(createPinia());
  const store = createStore();
  app.use(store);
  const router = createRouter();
  app.use(router);
  sync(store, router);
  app.use(VueZoomer);
  app.use(
    VueGtag,
    {
      config: {
        id: import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
      },
    },
    router
  );
  app.use(VueAgile);
  const metaManager = createMetaManager(false, {
    ...defaultConfig,
    meta: { tag: "meta", nameless: true },
  });
  app.use(metaManager);
}

export { addPlugins };
